import { useEffect, useId, useState } from 'react';
import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

function MermaidBlock({ source }: { source: string }) {
  const id = useId().replace(/[^a-z0-9]/gi, '');
  const [svg, setSvg] = useState('');
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    setSvg('');
    setFailed(false);
    void import('mermaid')
      .then(async ({ default: mermaid }) => {
        mermaid.initialize({ startOnLoad: false, securityLevel: 'strict' });
        const rendered = await mermaid.render(`inspection${id}`, source);
        if (!cancelled) setSvg(rendered.svg);
      })
      .catch(() => {
        if (!cancelled) setFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, [source, id]);
  // Rendering in an opaque, script-free iframe also isolates Mermaid SVG.
  return svg && !failed ? (
    <iframe
      title="Mermaid 图表"
      sandbox=""
      srcDoc={svg}
      className="inspector-mermaid"
    />
  ) : (
    <code>{source}</code>
  );
}

const markdownComponents: Components = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  // Remote images are links: reading a transcript must not issue tracking requests.
  img: ({ src, alt }) => (
    <a href={src} target="_blank" rel="noopener noreferrer">
      {alt || '查看图片'}
    </a>
  ),
  code: ({ className, children }) =>
    className === 'language-mermaid' ? (
      <MermaidBlock source={String(children)} />
    ) : (
      <code className={className}>{children}</code>
    ),
};

export function MessageMarkdown({ text }: { text: string }) {
  return (
    <div className="inspector-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        components={markdownComponents}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
